import type { EdgeId } from '@ipfabric/utils';
import {
  type GraphState,
  isPathLookupGraphMetadata,
} from 'components/Graph/GraphState';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface ShowPathLookupPathInspectorEdgeTooltipCommand {
  edgeId: EdgeId;
  position: {
    x: number;
    y: number;
  };
}

const isOneOfPathInspectorHighlightedEdges = (
  { graphMetadata, pathlookup: { pathInspector } }: GraphState,
  edgeId: EdgeId,
): boolean =>
  isPathLookupGraphMetadata(graphMetadata) &&
  Object.keys(pathInspector.selectedPackets).length > 0 &&
  pathInspector.activeNodeSn !== null &&
  pathInspector.highlightedEdges[pathInspector.activeNodeSn] !== undefined &&
  (pathInspector.highlightedEdges[
    pathInspector.activeNodeSn
  ]?.incomingEdges.includes(edgeId) ||
    // Fixed noUncheckedIndexedAccess NIM-19408
    pathInspector.highlightedEdges[
      pathInspector.activeNodeSn
    ]!.outgoingEdges.includes(edgeId));

export const showPathLookupPathInspectorEdgeTooltip: GraphCommandFactory<
  ShowPathLookupPathInspectorEdgeTooltipCommand
> = (cmdContext) => (command) => {
  if (
    isOneOfPathInspectorHighlightedEdges(cmdContext.getState(), command.edgeId)
  ) {
    cmdContext.updateState((draft) => {
      draft.tooltip = {
        moveWithMouse: true,
        payload: {
          type: 'pathLookupPathInspectorEdge',
          edgeId: command.edgeId,
        },
        position: command.position,
      };
    });
  }
};
